module.exports = __webpack_public_path__ + "img/corpuls_corpuls1.d3502624.png";